import { memo } from 'react';

import TextIconSVG from '@/assets/text-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ITextIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={TextIconSVG} {...props} />;

export const TextIcon = memo(ITextIcon) as typeof ITextIcon;
